// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PTrophyOutlinedSvg from "@fishx/icons-svg/es/asn/PTrophyOutlined";
import FishxIcon from '../components/FishxIcon';

var PTrophyOutlined = function PTrophyOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PTrophyOutlinedSvg
  }));
};

PTrophyOutlined.displayName = 'PTrophyOutlined';
export default React.forwardRef(PTrophyOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PTrophyOutlined.js
// module id = 3691
// module chunks = 0